import * as yup from 'yup';

export const schemaNousJoindre = yup.object({
    firstName: yup.string().required('Ce champ est requis'),
    lastName: yup.string().required('Ce champ est requis'),
    email: yup.string().email('Ce champ doit contenir une adresse courriel valide').required('Ce champ est requis'),
    phone: yup.string().required('Ce champ est requis'),
    poste: yup.string(),
    organisationName: yup.string(),
    objet: yup.string(),
    message: yup.string().required('Ce champ est requis'),
});
